import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { getCourses, getExamsByCourse, createExamAttempt, getExamAttemptsByExamByUser } from './services/db';
function preventDefault(event) {
  event.preventDefault();
}

export default function Orders() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [examEnabled, setExamEnabled] = useState(null);

  const blFacialRecognition = (examId, courseId) => {
    let formdata = new FormData();

    formdata.append("user", localStorage.getItem("user"));
    formdata.append("key", localStorage.getItem("klarwayProctoringKey"));
    formdata.append("exam", examId);
    // formdata.append("isExtension", localStorage.getItem("isExtension"))
    
    let myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + localStorage.getItem("token"));
    myHeaders.append("Agent", "Klarway-ext");

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(`${localStorage.getItem("k_url")}/blFacialRecognition/v2`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setExamEnabled(examId);
        }else{
          console.log("blFacialRecognition success false", result);  
        }
      })
      .catch((error) => {
        console.log("blFacialRecognition error", error);
      });
  };

  const blPlayExam = async (examId, courseId) => {
    // const examFB = await getExam(examSelected.examId, examSelected.courseId);
    let attempt = await createExamAttempt({userId:localStorage.getItem("user"), examId: examId, courseId: courseId, environment:localStorage.getItem("env")})
    // console.log(attempt)

    let numAttempts = await getExamAttemptsByExamByUser(examId, localStorage.getItem("user"), localStorage.getItem("env"))
    // console.log(numAttempts, numAttempts.length)
    // setAttempt(numAttempts.length)

    var formdata = new FormData();
    formdata.append("user", localStorage.getItem("user"));
    formdata.append("key", localStorage.getItem("klarwayProctoringKey"));
    // formdata.append("exam_id", examId);
    formdata.append('attempt_from_sis', numAttempts.length)

    let myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + localStorage.getItem("token"));
    myHeaders.append("Agent", "Klarway-ext");

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(`${localStorage.getItem("k_url")}/blPlayExam/v2`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log("blPlayExam result!", result);
        if (result.success) {
          global.showExam(examId, courseId, attempt);
        }else{
          console.log("blPlayExam success false", result);  
        }
      })
      .catch((error) => console.log("blPlayExam error!", error));
  };

  useEffect(() => {
    let mounted = true;

    const loadExams = async () => {
      try {
        const courses = await getCourses();
        if (!courses.length) return;

        const firstCourse = courses[0];
        const exams = await getExamsByCourse(firstCourse.id);

        if (!mounted) return;
        setRows(
          exams.map((exam) => ({
            id: exam.id,
            courseId: firstCourse.id,
            course: firstCourse.name,
            exam: exam.name,
            description: `Preguntas: ${Object.keys(exam.questions || {}).length}`,
          })),
        );
      } catch (error) {
        console.error('Error cargando exámenes', error);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    loadExams();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <React.Fragment>
      <Table style={{ marginTop: 80 }} size="small">
        <TableHead>
          <TableRow>
            {/* <TableCell>Carrera</TableCell> */}
            <TableCell>Curso</TableCell>
            <TableCell>Examen</TableCell>
            <TableCell>Descripción</TableCell>
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow style={{ marginTop: 50 }} key={row.id}>
              <TableCell>
                <Typography color={"#616161"} variant={"subtitle2"}>
                  {row.course}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography color={"#616161"} variant={"subtitle2"}>
                  {row.exam}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography color={"#616161"} variant={"subtitle2"}>
                  {row.description}
                </Typography>
              </TableCell>
              {/* <TableCell>
                <Typography color={"#616161"} variant={"subtitle2"}>
                  {row.turno}
                </Typography>
              </TableCell> */}
              <TableCell align="right">
                {
                  <Button
                    type="submit"
                    style={{ color: "#fff", backgroundColor: "#009efd" }}
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                    onClick={async () => {
                      let checkE = await global.checkExam(row.id, row.courseId);
                      if(checkE){
                        if (examEnabled == row.id) {
                          blPlayExam(row.id, row.courseId);
                        } else {
                          blFacialRecognition(row.id, row.courseId);
                        }
                      }else{
                        global.showExam(row.id, row.courseId);
                      }
                    }}
                  >
                    {examEnabled == row.id ? "Rendir" : "Habilitar"}
                  </Button>
                }
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </React.Fragment>
  );
}
